var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"no-gutters":""}},[(_vm.timetables.length > 0)?_c('b-col',{},[_vm._v(" "+_vm._s(_vm.labels)+" ")]):_c('b-col',[_vm._v(" "+_vm._s(_vm.$t('components.custom.table.no-available-timetable'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }